import React from 'react'

import { Navbar, Footer } from '../../../components';
import { Article12Doc } from '../individual';

export default function Article12() {
  return (
    <div className='emas__article12'>
        <Navbar />
        <Article12Doc />
        <Footer />
    </div>
  )
}
